import { type ApolloError, useQuery } from '@apollo/client';

import { GET_LATE_ADD_TO_CART_ORDER_ELIGIBILITY } from '../queries/order';
import type { GetLateAddToCartOrderEligibilityQueryResult } from '../types/order';

export type UseLateAddToCartOrderEligibilityResult = {
  isEligible: boolean;
  loading: boolean;
  error?: ApolloError;
};

export const useLateAddToCartOrderEligibility = (
  orderId: string,
): UseLateAddToCartOrderEligibilityResult => {
  const { data, loading, error } =
    useQuery<GetLateAddToCartOrderEligibilityQueryResult>(
      GET_LATE_ADD_TO_CART_ORDER_ELIGIBILITY,
      {
        variables: { orderId },
        // We want the eligibility info to be always up to date
        fetchPolicy: 'network-only',
      },
    );

  return {
    isEligible: data?.getLateAddToCartOrderEligibility?.isEligible ?? false,
    loading,
    error,
  };
};
